<template>
    <svg height="17" viewBox="0 0 20.4 17" width="20.4" xmlns="http://www.w3.org/2000/svg">
        <path
            id="Icon_material-reply"
            d="M16.967,12.033V7.5L24.9,15.433l-7.933,7.933V18.72C11.3,18.72,7.333,20.533,4.5,24.5,5.633,18.833,9.033,13.167,16.967,12.033Z"
            data-name="Icon material-reply"
            fill="#afafaf"
            transform="translate(-4.5 -7.5)"
        />
    </svg>
</template>

<script>
export default {
    name: "ForwardRepresentative",
};
</script>
